import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent {
  input: string;
  isListVisible: boolean;
  items: Array<any> = [];

  @Input() placeholder: string;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  getAllItems(): any {

  }

  onSelect(item: any): any {
    this.selected.emit(item);
    this.isListVisible = false;
    this.input = item.name;
  }

  trackByFn(index: number): number {
    return index;
  }
}
